import SuperJSON from "superjson";
import Id from "../types/Id";

export default class VariableId extends Id<"variable"> {}

SuperJSON.registerClass(VariableId, { identifier: "VariableId" });
